import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, MapPinIcon, ShoppingBagIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/content';
export function FloatingElements() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [index, setIndex] = useState(0);
  const [cta, setCta] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const delay = index === 0 ? 4500 : 7500;
    const showTimer = window.setTimeout(() => setVisible(true), delay);
    const rotateTimer = window.setTimeout(() => {
      setVisible(false);
      setIndex(value => (value + 1) % recentPurchases.length);
    }, delay + 5500);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(rotateTimer);
    };
  }, [dismissed, index]);
  useEffect(() => {
    const onScroll = () => setCta(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const [name, place] = recentPurchases[index];
  return <>
      <AnimatePresence data-id="element-149" data-mp="drhuafmhkcc2">
        {visible && !dismissed && <motion.aside initial={{
        opacity: 0,
        y: 26,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.96
      }} transition={{
        type: 'spring',
        stiffness: 280,
        damping: 24
      }} className="fixed bottom-4 left-4 z-[60] max-w-[290px] overflow-hidden rounded-2xl border-[3px] border-gold bg-primary p-3 pr-8 shadow-[0_18px_42px_rgba(226,85,44,.45)]" aria-live="polite" data-id="element-150" data-mp="dpyd8mt09x98">
            <div className="absolute inset-y-0 left-0 w-1.5 bg-gold" data-id="element-151" data-mp="11gavaqhytadj" />
            <button onClick={() => setDismissed(true)} className="absolute right-1.5 top-1.5 rounded p-1 text-white/70 transition-colors duration-150 ease-out hover:text-white" aria-label="Cerrar notificación" data-id="element-152" data-mp="15j77nzgwwa91">
              <XIcon className="h-3.5 w-3.5" data-id="element-153" data-mp="32j1ysc9630us" />
            </button>
            <div className="flex gap-3" data-id="element-154" data-mp="32kwkhss9iwzx">
              <span className="h-fit rounded-full border-2 border-amber-100 bg-gold p-2 text-white shadow-sm" data-id="element-155" data-mp="3ga6r0ta7gqv3">
                <ShoppingBagIcon className="h-5 w-5" data-id="element-156" data-mp="3bj89xrhe7oqs" />
              </span>
              <div data-id="element-157" data-mp="3q8mfsplrfo1f">
                <p className="flex items-center gap-1 text-[10px] font-black uppercase tracking-[.12em] text-amber-200" data-id="element-158" data-mp="3q84ma0qhfnx7">
                  <CheckCircle2Icon className="h-3 w-3" data-id="element-159" data-mp="3l8i2f8g5f9ff" /> Compra reciente
                </p>
                <p className="mt-1 text-xs leading-snug text-white/90" data-id="element-160" data-mp="32vi4erx2n4o">
                  <b className="text-white" data-id="element-161" data-mp="3uahj1zn94bhu">{name}</b> compró el libro digital{' '}
                  <b className="text-amber-200" data-id="element-162" data-mp="24vbbz67ncne0">Entrenamiento en Casa</b>
                </p>
                <p className="mt-1 flex items-center gap-1 text-[10px] font-semibold text-white/80" data-id="element-163" data-mp="24x4jenq33bn2">
                  <MapPinIcon className="h-3 w-3 text-amber-200" data-id="element-164" data-mp="1zykxuofek1v8" />
                  {place} · Argentina · hace {index * 4 + 2} min
                </p>
              </div>
            </div>
          </motion.aside>}
      </AnimatePresence>

      <AnimatePresence data-id="element-165" data-mp="6kt0pz5tbujy">
        {cta && <motion.a href="#pricing" initial={{
        y: 80,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 80,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-3 left-3 right-3 z-50 rounded-2xl bg-primary py-3.5 text-center text-sm font-extrabold uppercase text-white shadow-lg shadow-primary/30 md:hidden" data-id="element-166" data-mp="6jrkzhduqjvw">
            🎯 Quiero mi programa ahora →
          </motion.a>}
      </AnimatePresence>
    </>;
}